export class UiRouterUtil {
    static componentBindings (bindings) {
        const resolve: any[] = [];
        for (const key of Object.keys(bindings)) {
            resolve.push({
                token: key,
                resolveFn: () => bindings[key],
            });
        }
        return resolve;
    }
}
